<template>
  <div class="contact-info">
    <div class="contact-info__edit text-right">
      <h3 class="font-size-16 primary-color font-family-Semibold cursor-pointer">Chỉnh sửa</h3>
    </div>
    <div class="contact-info__mail-phone display-flex">
      <div class="email col-lg-6 col-md-6 col-12">
        <label class="secondary-color-txt font-sanpro-semibold" for>Email</label>
        <br />
        <input type="text" placeholder="nguyenvanan@gmail.com"  v-model="getBaseInfo.email"/>
      </div>
      <div class="phone col-lg-6 col-md-6 col-12">
        <label class="secondary-color-txt font-sanpro-semibold" for>Số điện thoại</label>
        <br />
        <input type="text" placeholder="Số điện thoại của bạn" v-model="getBaseInfo.phoneNumber" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { STORE_KEY } from "../../_store/constants";
export default {
  name: "Contact",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      getBaseInfo: STORE_KEY + "/getBaseInfo"
    })
  }
};
</script>

<style lang="scss" scoped>
.contact-info {
  &__mail-phone {
    input {
      background-color: #f3f6fb;
      border: 0;
      border-radius: 20px;
      padding-left: 15px;
      height: 32px;
      line-height: 32px;
      width: 100%;
    }
    .email,
    .phone {
      margin-bottom: 15px;
    }
  }
}
@media (max-width: 425px) {
  .contact-info__mail-phone {
    display: block;
  }
}
</style>